import ApplicationController from './application_controller'

export default class extends ApplicationController {

  connect () {
    if (!this.element.value == '') {
      this.grow()
    }
  }

  grow () {
    if (this.element.hasAttribute('rows')) {
      this.element.removeAttribute('rows')
    }

    this.element.style.height = 'auto'
    this.element.style.height = this.element.scrollHeight + 'px'

    if (this.embedded) {
      this.embedded.reportWidgetSize()
    }
  }
}
